// @flow
import React from 'react'
import I18n from 'i18n-react'
import classNames from 'classnames'

type TextFilterProps = {
  checked: boolean,
  classNames?: string,
  domain: { name: string, value: string },
  lgClassesGrid?: boolean,
  onChange: (name: string, checked: boolean) => void,
  parentName?: string,
  textMode: boolean,
}

const TextFilter = (props: TextFilterProps) => {
  const handleOnChange = (event: SyntheticInputEvent<HTMLInputElement>) => {
    props.onChange(props.domain.name, event.target.checked)
  }

  if (props.textMode) {
    return props.checked &&
      <li className='d-block d-sm-inline-block'>
        <strong>{props.domain.value}</strong>
      </li>
  }

  const id = `filter-${props.parentName || ''}-${props.domain.name}`
  const classes = [props.classNames ? props.classNames : 'col-6 col-sm-3 col-lg-3 col-xl-6 py-2']

  return (
    <div className={classNames(classes)}>
      <div className='custom-control custom-checkbox'>
        <input
          checked={props.checked}
          className='custom-control-input'
          data-hj-whitelist
          id={id}
          onChange={handleOnChange}
          type='checkbox'
        />
        <label
          className='custom-control-label'
          htmlFor={id}
        >
          {I18n.translate(`filter.values.${props.domain.name}`)}
        </label>
      </div>
    </div>
  )
}

export default TextFilter
